export const ALL = 'all';
export const ALLOWED_LANGUAGES = [
  { fullName: 'Česky', locale: 'cs' },
  { fullName: 'English', locale: 'en' },
  { fullName: 'Slovensky', locale: 'sk' },
  { fullName: 'Italsky', locale: 'it' },
];
export const BASE_URL_EVENTS = '/api/v1/events/';
export const BASE_URL_ORDER = '/api/v1/orders/';
export const BASE_URL_ARES = '/api/v1/ares/';
export const BASE_URL_BOOKS = '/api/collections/books/entries/';
export const BASE_URL_SANCTUM = '/sanctum/csrf-cookie/';
export const BOTH_TYPE = 'both';
export const CZK = 'Kč';
export const DEFAULT_CURRENCY = 'CZK';
export const EUR = 'EUR';
export const FREE_TEXT = 'Volno';
export const MORNING = 'morning';
export const AFTERNOON = 'afternoon';
export const HALF_DAY_MORNING = 'half_day_morning';
export const HALF_DAY_AFTERNOON = 'half_day_afternoon';
export const HALF_OCUPATION = '50% obsazenost';
export const IN_PERSON_TYPE = 'in_person';
export const LAST_AVAILABLE_PLACES_TEXT = 'Poslední volná místa';
export const ONLINE = 'Online';
export const SOLD_OUT_MARK = 'X';
export const SOLD_OUT_TEXT = 'Vyprodáno';
export const FREE = 'Zdarma';
export const SOLD_OUT_THRESHOLD = 2;
export const VAT = 1.12;
export const VIRTUAL = 'virtual';
export const SERVICE_ACCOMODATION_ID = 1;
export const SERVICE_PARKING_ID = 2;
